/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./pages/Home";
import Kontrak from "./pages/Kontrak";
import BuatKontrak from "./pages/BuatKontrak";
import Billing from "./pages/Billing";
import QRCodeGenerator from "./pages/QRCodeGenerator";
import Rtl from "./pages/Rtl";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import "antd/dist/reset.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/sign-up" exact component={SignUp} />
        <Route path="/" exact component={SignIn} />
        <Route path="/sign-in" exact component={SignIn} />
        <Main>
          <Route exact path="/dashboard" component={Home} />
          <Route exact path="/kontrak" component={Kontrak} />
          <Route exact path="/buat_kontrak/:id" component={BuatKontrak} />
          <Route exact path="/buat_kontrak" component={BuatKontrak} />
          <Route exact path="/billing" component={Billing} />
          <Route exact path="/qrcode" component={QRCodeGenerator} />
          <Route exact path="/rtl" component={Rtl} />
          <Route exact path="/profile" component={Profile} />
          {/* <Redirect from="/" to="/sign-in" /> */}
        </Main>
      </Switch>
    </div>
  );
}

export default App;
